__webpack_require__.p = "https://nbbrl-res.jlzsjc.com/frontend/alpha/gaming-platform-brl-h5/";